import { i18n } from '@/services/i18n';

export const APARTMENT_TYPES = {
  APARTMENT: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.APARTMENT'),
  GROUND_FLOOR: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.GROUND_FLOOR'),
  ROOF_STOREY: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.ROOF_STOREY'),
  MAISONETTE: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.MAISONETTE'),
  HALF_BASEMENT: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.HALF_BASEMENT'),
  LOFT: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.LOFT'),
  RAISED_GROUND_FLOOR: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.RAISED_GROUND_FLOOR'),
  PENTHOUSE: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.PENTHOUSE'),
  TERRACED_FLAT: i18n.t('WIZARD.ACCESSIBILITY.APARTMENT_TYPES.TERRACED_FLAT'),
};

export const ALTERNATIVE_HEATING_TYPES = {
  GEO_THERMAL_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.GEO_THERMAL_HEATING'),
  HEAT_PUMP: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.HEAT_PUMP'),
  PELLET_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.PELLET_HEATING'),
  DISTRICT_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.DISTRICT_HEATING'),
  SOLAR_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.SOLAR_HEATING'),
};

export const HEATING_TYPES = {
  GAS_CENTRAL_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.GAS_CENTRAL_HEATING'),
  GAS_FLOOR_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.GAS_FLOOR_HEATING'),
  OIL_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.OIL_HEATING'),
  DISTRICT_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.DISTRICT_HEATING'),
  PELLET_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.PELLET_HEATING'),
  ELECTRIC_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.ELECTRIC_HEATING'),
  COGENERATION_UNIT: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.COGENERATION_UNIT'),
  SOLAR_THERMAL_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.SOLAR_THERMAL_HEATING'),
  HEAT_PUMP: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.HEAT_PUMP'),
};

export const OBSOLETE_HEATING_TYPES = {
  GAS_CENTRAL_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.GAS_CENTRAL_HEATING'),
  GAS_FLOOR_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.GAS_FLOOR_HEATING'),
  OIL_HEATING: i18n.t('WIZARD.HEATING_RENOVATION.HEATING_OPTIONS.OIL_HEATING'),
};

export const BATHROOM_TYPES = {
  BATHROOM_WITH_WINDOW: i18n.t('WIZARD.BATHROOM.BATHROOM_OPTIONS.BATHROOM_WITH_WINDOW'),
  INTERIOR_BATHROOM: i18n.t('WIZARD.BATHROOM.BATHROOM_OPTIONS.INTERIOR_BATHROOM'),
  SEPARATE_GUEST_WC: i18n.t('WIZARD.BATHROOM.BATHROOM_OPTIONS.SEPARATE_GUEST_WC'),
};

export const BASEMENT_TYPES = {
  HAS_BASEMENT_COMPARTMENT: i18n.t('WIZARD.BASEMENT.TYPE.CELLAR'),
  HAS_PARTIAL_BASEMENT: i18n.t('WIZARD.BASEMENT.TYPE.PARTIAL'),
  HAS_CELLAR: i18n.t('WIZARD.BASEMENT.TYPE.BASEMENT'),
};

export const OUTDOOR_TYPES = {
  HAS_BALCONY: i18n.t('WIZARD.BALCONY_TERRACE.TYPE.BALCONY'),
  HAS_LOGGIA: i18n.t('WIZARD.BALCONY_TERRACE.TYPE.LOGGIA'),
  HAS_TERRACE: i18n.t('WIZARD.BALCONY_TERRACE.TYPE.TERRACE'),
  HAS_WINTER_GARDEN: i18n.t('WIZARD.BALCONY_TERRACE.TYPE.WINTER_GARDEN'),
};

export const WINDOW_TYPES = {
  HAS_WINDOW_ORIGINAL_STATE: i18n.t('WIZARD.WINDOW_RENOVATION.ORIGINAL'),
  HAS_WINDOW_NEEDS_RENOVATION: i18n.t('WIZARD.WINDOW_RENOVATION.NEED_RENOVATION'),
  HAS_WINDOW_MODERNIZED: i18n.t('WIZARD.WINDOW_RENOVATION.MODERNIZED'),
};

export const FINANCING_STATUS_TYPES = {
  FINANCING_CERTIFICATE_PRESENT: i18n.t(
    'DASHBOARD.CARD.EXPANDED.CALLBACK.FINANCING_CERTIFICATE_PRESENT',
  ),
  FINANCING_UNCLEAR: i18n.t('DASHBOARD.CARD.EXPANDED.CALLBACK.FINANCING_UNCLEAR'),
  FINANCING_CONFIRMED: i18n.t('DASHBOARD.CARD.EXPANDED.CALLBACK.FINANCING_CONFIRMED'),
  FINANCING_REQUESTED: i18n.t('DASHBOARD.CARD.EXPANDED.CALLBACK.FINANCING_REQUESTED'),
};

export const BUYING_PURPOSE = {
  OWN_USE: i18n.t('DASHBOARD.CARD.EXPANDED.CALLBACK.BUYING_PURPOSE.OWN_USE'),
  INVESTMENT: i18n.t('DASHBOARD.CARD.EXPANDED.CALLBACK.BUYING_PURPOSE.INVESTMENT'),
};

export const PROMPT_FLOW_TITLE = {
  FIRST_APPOINTMENT: i18n.t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.FIRST_APPOINTMENT'),
  CANCEL_FIRST_APPOINTMENT: i18n.t(
    'DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.CANCEL_FIRST_APPOINTMENT',
  ),
  NOTARY_APPOINTMENT: i18n.t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.NOTARY_APPOINTMENT'),
  CLOSE_BROKER_ORDER_GENERAL_REMINDER: i18n.t(
    'DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.CLOSE_BROKER_ORDER_GENERAL_REMINDER',
  ),
  VIEWING_APPOINTMENT: i18n.t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.VIEWING_APPOINTMENT'),
  CANCEL_VIEWING_APPOINTMENT: i18n.t(
    'DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.CANCEL_VIEWING_APPOINTMENT',
  ),
  VIRTUAL_VIEWING_APPOINTMENT: i18n.t(
    'DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.VIRTUAL_VIEWING_APPOINTMENT',
  ),
  BUYER_CALLBACK_REQUEST: i18n.t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.BUYER_CALLBACK_REQUEST'),
  BUYER_MORTGAGE_ACTION: i18n.t('DASHBOARD.CARD.EXPANDED.STATUS_PROMPT.BUYER_MORTGAGE_ACTION'),
};

export const PARTICIPANT_ROLE_TYPES = (gender) => {
  const genderUpperCased = gender?.toUpperCase();
  return {
    OWNER: i18n.t(`DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.OWNER_${genderUpperCased}`),
    SPOUSE_OF_OWNER: i18n.t(
      `DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.SPOUSE_OF_OWNER_${genderUpperCased}`,
    ),
    RELATIVE_OF_OWNER: i18n.t(
      `DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.RELATIVE_OF_OWNER_${genderUpperCased}`,
    ),
    TENANT: i18n.t(`DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.TENANT_${genderUpperCased}`),
    FACILITY_MANAGER: i18n.t(
      `DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.FACILITY_MANAGER_${genderUpperCased}`,
    ),
    ADMINISTRATION: i18n.t('DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.ADMINISTRATION'),
    SPECIAL_ADMINISTRATION: i18n.t('DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.SPECIAL_ADMINISTRATION'),
    ADMINISTRATION_AND_SPECIAL_ADMINISTRATION: i18n.t(
      'DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.ADMINISTRATION_AND_SPECIAL_ADMINISTRATION',
    ),
    NOTARY: i18n.t(`DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.NOTARY_${genderUpperCased}`),
    LEAD_PROVIDER: i18n.t(`DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.LEAD_PROVIDER_${genderUpperCased}`),
    COOPERATION_PARTNER: i18n.t(
      `DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.COOPERATION_PARTNER_${genderUpperCased}`,
    ),
    OTHER: i18n.t('DASHBOARD.CARD.EXPANDED.CONTACT.ROLE.OTHER'),
  };
};

export const POSTPONE_TASK_OPTIONS = {
  THIS_EVENING: i18n.t('DASHBOARD.CARD.EXPANDED.TASKS.POSTPONE_OPTIONS.THIS_EVENING'),
  TOMORROW: i18n.t('DASHBOARD.CARD.EXPANDED.TASKS.POSTPONE_OPTIONS.TOMORROW'),
  NEXT_WEEK: i18n.t('DASHBOARD.CARD.EXPANDED.TASKS.POSTPONE_OPTIONS.NEXT_WEEK'),
};
